import {
    Component, DestroyRef, inject, ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { UserService } from 'src/app/services/user.service';
import { ApolloService, getOrganizations_organizations } from 'src/gql-generated/generated';
import { TableComponent, TableSettings } from '../../shared/table/table.component';
import { NgClass, NgIf } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-organizations',
    templateUrl: './organizations.component.html',
    styleUrl: './organizations.component.scss',
    imports: [
        NgClass,
        MatFormField,
        MatInput,
        ReactiveFormsModule,
        MatButton,
        RouterLink,
        NgIf,
        TableComponent,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatIcon,
    ],
})
export class OrganizationsComponent {
    /**
     * Reference to orgfanizations table
     */
    @ViewChild('table') table?: TableComponent;

    /**
     * Custom search control
     */
    searchControl = new FormControl('');

    /**
     * Settings for organizations table
     */
    organizationTableSettings: TableSettings = {
        getItems: (paginator, search) => firstValueFrom(this.apollo.getOrganizations({
            limit: paginator.pageSize,
            offset: paginator.pageSize * paginator.pageIndex,
            where: {
                deleted_at: { _is_null: true },
                name: { _ilike: `%${search}%` },
            },
        })),
        routerLinkFunction: (item) => `/settings/organizations/${item.id}`,
        hideSearch: true,
        hidePageSize: true,
    };

    /**
     * Destroy ref used in takeUntilDestroyed
     */
    private destroyRef = inject(DestroyRef);

    constructor(
        private apollo: ApolloService,
        public organizationService: OrganizationService,
        private user: UserService,
        public breakpoint: BreakpointService,
    ) { }

    /**
     * Handle "switch" button press in table
     * @param organization Organization to switch to
     * @param table Reference to table to update
     */
    switchOrganization(organization: getOrganizations_organizations, table: TableComponent): void {
        this.organizationService.setOrganization(organization, this.user.profile.id);
        table.updateData.next();
    }

    /**
     * Logic after view is initialzied
     */
    ngAfterViewInit(): void {
        // Pass local searchControl values to table searchControl
        if (this.table) {
            this.searchControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((s) => this.table?.searchControl.setValue(s));
        }
    }
}
